export default "<ion-searchbar placeholder='Search by Food, Drinks, Household Essentials & Places'></ion-searchbar>\r\n";